import { parseISO } from 'date-fns';

import { isNil } from 'lodash';

import moment from 'moment-timezone';

import PropTypes from 'prop-types';

import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import Form from 'react-validation/build/form';
import Select from 'react-validation/build/select';
import {
	Modal,
	ModalBody,
	ModalHeader,
} from 'reactstrap';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import InfoIcon from '@material-ui/icons/Info';

import CustomCheckbox from 'atoms/CustomCheckbox';
import CustomDatePicker from 'atoms/CustomDatePicker';
import CustomTimePicker from 'atoms/CustomTimePicker';
import { formatEndDateForApi } from 'utils/groupForm';
import {
	getObjectDifference,
} from 'utils/helpers';

import './index.css';
import SelectAutoComplete from 'atoms/SelectAutoComplete';
import SessionDeletionWarningModal from '../SessionDeletionWarningModal';
import ClinicianTenureModal from '../ClinicianTenureModal';

/**
 *
 * UpdateGroup
 *
 */

/* eslint-disable react/prefer-stateless-function */

const repeatAction = ['Weekly']; //, 'Daily'];

class UpdateGroup extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			modal: true,
			price: '',
			location: 'Marin',
			activeTab: '1',
			startDate: new Date(),
			endDate: null,
			repeats: 'Weekly',
			groupType: '',
			startTime: moment().toDate(),
			endTime: moment().add(1, 'hour').toDate(),
			repeatsOn: [],
			groupSize: 'Group',
			weekDays: [
				{ name: 'Mon', isSelected: false, value: 'Monday' },
				{ name: 'Tue', isSelected: false, value: 'Tuesday' },
				{ name: 'Wed', isSelected: false, value: 'Wednesday' },
				{ name: 'Thu', isSelected: false, value: 'Thursday' },
				{ name: 'Fri', isSelected: false, value: 'Friday' },
				{ name: 'Sat', isSelected: false, value: 'Saturday' },
				{ name: 'Sun', isSelected: false, value: 'Sunday' },
			],
			inPerson: false,
			meetingLink: '',
			timeZone: 'America/Los_Angeles',
			clinicianIds: [],
			showSessionWarning: false,
			affectedSessions: [],
			pendingStateData: null,
			showTenureModal: false,
			selectedClinicianForTenure: null,
			clinicianTenures: {}, // Map of clinicianId -> tenure array
			preTenureModalState: null, // { clinicianIds, clinicianTenures } before modal opened
		};
	}

	// Returns sorted array of clinician IDs that have at least one active tenure
	static getActiveClinicianIds(clinicians) {
		const today = moment().format('YYYY-MM-DD');
		const uniqueIds = [...new Set(clinicians.map((c) => c.clinicianId))];
		return uniqueIds.filter((id) => {
			const tenures = clinicians.filter((c) => c.clinicianId === id);
			return tenures.some((t) => !t.endDate || t.endDate >= today);
		}).sort((a, b) => a - b);
	}

	// converts clinicianIds props into array of objects needed for SelectAutoComplete
	getClinicianIds = () => {
		const { clinicians } = this.props;
		return this.state.clinicianIds.map((id) => ({
			value: id,
			label: clinicians.find((clinician) => clinician.id === id)?.name,
		}));
	};

	componentDidMount() {
		this.setState({
			repeats: repeatAction[0],
		});
		const { mode, groupData, role, id, clinicians } = this.props;

		let {
			groupName,
			location,
			groupSize,
			price,
			repeatsOn,
			repeatFrequency,
			startTime,
			endTime,
			startDate,
			endDate,
			inPerson,
			meetingLink,
			clinicians: groupClinicians
		} = groupData;

		// Handle null/undefined values with explicit defaults
		repeatsOn = repeatsOn || [];
		groupClinicians = groupClinicians || [];

		// Build tenure map from existing data
		const clinicianTenures = {};
		if (groupData.clinicians) {
			groupData.clinicians.forEach((c) => {
				if (!clinicianTenures[c.clinicianId]) {
					clinicianTenures[c.clinicianId] = [];
				}
				clinicianTenures[c.clinicianId].push({
					id: c.id,
					startDate: c.startDate,
					endDate: c.endDate,
				});
			});
		}

		// Extract unique IDs, only for clinicians with at least one active tenure
		const clinicianIds = UpdateGroup.getActiveClinicianIds(groupClinicians);

		if (mode === 'edit') {
			const startTimeString = startTime
				? moment.utc(startTime).tz(this.state.timeZone).format('YYYY-MM-DDTHH:mm:ss')
				: moment().hour(9).minute(0).format('YYYY-MM-DDTHH:mm:ss');
			const endTimeString = endTime
				? moment.utc(endTime).tz(this.state.timeZone).format('YYYY-MM-DDTHH:mm:ss')
				: moment().hour(10).minute(0).format('YYYY-MM-DDTHH:mm:ss');

			startTime = new Date(startTimeString);
			endTime = new Date(endTimeString);

			this.setState({
				groupType: groupName,
				location,
				groupSize,
				price,
				repeatsOn: [...repeatsOn],
				repeats: repeatFrequency || 'Weekly',
				startTime,
				endTime,
				startDate: startDate ? moment(startDate).toDate() : new Date(),
				endDate: endDate ? parseISO(moment.utc(endDate).format('YYYY-MM-DD')) : null,
				inPerson: inPerson || false,
				meetingLink: meetingLink || '',
				clinicianIds,
				clinicianTenures,
			});

			if (repeatFrequency === 'Weekly' && repeatsOn.length > 0) {
				const { weekDays } = this.state;
				for (let day of repeatsOn) {
					const weekIndex = weekDays.findIndex((week) => week.value === day);
					if (weekIndex >= 0) {
						weekDays[weekIndex].isSelected = true;
					}
				}

				this.setState({
					weekDays,
				});
			}
		}
		if (mode === 'create' && role === 'clinician') {
			this.setState({ clinicianIds: [parseInt(id, 10)] });
		}
		if (
			mode === 'create' &&
			role === 'admin' &&
			clinicians &&
			clinicians.length
		) {
			this.setState({ clinicianIds: [] });
		}
	}

	componentDidUpdate(prevProps) {
		// Watch for isUpdating to transition from true to false
		if (prevProps.isUpdating && !this.props.isUpdating) {
			if (this.props.updateConflict) {
				// Show session warning with conflict data from the server
				this.setState({
					showSessionWarning: true,
					affectedSessions: this.props.updateConflict.affectedSessions || [],
				});
			}
		}
	}

	closeModal = () => {
		const { hide } = this.props;
		hide();
	};

	toggle = (tab) => {
		if (this.state.activeTab !== tab) {
			this.setState({
				activeTab: tab,
			});
		}
	};

	handleChange = (event) => {
		const {
			target: { name, value },
		} = event;

		this.setState({ [name]: value });
	};

	handleCheck = (name) => () => {
		this.setState({ [name]: !this.state[name] });
	};

	repeating = (e) => {
		this.setState({
			repeats: e.currentTarget.textContent,
		});
	};

	weekDaysSelect = (e, index) => {
		const weekDays = this.state.weekDays.map((weekDay, i) =>
			i === index ? { ...weekDay, isSelected: !weekDay.isSelected } : weekDay,
		);

		this.setState({
			weekDays,
			// Read back from the chips, so a save sends the days shown, in week order. The
			// API's getAllGivenDaysBetweenTimeRange (create, schedule edits) steps from each
			// listed day to the next: Mon, Fri, Wed would schedule three sessions a fortnight.
			repeatsOn: weekDays
				.filter((weekDay) => weekDay.isSelected)
				.map((weekDay) => weekDay.value),
		});
	};

	handleMultiSelect = (event) => {
		const selected = event || [];
		const newIds = selected.map((c) => c.value);
		const oldIds = this.state.clinicianIds;

		// Check for newly added clinician
		const addedId = newIds.find((id) => !oldIds.includes(id));
		if (addedId) {
			const clinician = this.props.clinicians.find((c) => c.id === addedId);
			this.setState({
				preTenureModalState: {
					clinicianIds: this.state.clinicianIds,
					clinicianTenures: this.state.clinicianTenures,
				},
				clinicianIds: newIds,
				showTenureModal: true,
				selectedClinicianForTenure: clinician,
			});
			return;
		}

		// Check for removed clinician (clicked X)
		const removedId = oldIds.find((id) => !newIds.includes(id));
		if (removedId) {
			const clinician = this.props.clinicians.find((c) => c.id === removedId);
			// Set end date to today for current active tenure
			const tenures = this.state.clinicianTenures[removedId] || [];
			const updatedTenures = tenures.map((t) => {
				if (!t.endDate) {
					return { ...t, endDate: moment().format('YYYY-MM-DD') };
				}
				return t;
			});

			this.setState({
				preTenureModalState: {
					clinicianIds: this.state.clinicianIds,
					clinicianTenures: this.state.clinicianTenures,
				},
				showTenureModal: true,
				selectedClinicianForTenure: clinician,
				clinicianTenures: {
					...this.state.clinicianTenures,
					[removedId]: updatedTenures,
				},
			});
			return;
		}

		this.setState({ clinicianIds: newIds });
	};

	handleSaveTenures = (tenures) => {
		const clinicianId = this.state.selectedClinicianForTenure?.id;
		if (!clinicianId) return;

		// Check if all tenures are deleted or ended
		const activeTenures = tenures.filter((t) => !t.delete);
		const today = moment().format('YYYY-MM-DD');
		const allTenuresEnded = activeTenures.length > 0 &&
			activeTenures.every((t) => t.endDate && t.endDate < today);

		let newClinicianIds = [...this.state.clinicianIds];
		if (activeTenures.length === 0 || allTenuresEnded) {
			// Remove clinician from list
			newClinicianIds = newClinicianIds.filter((id) => id !== clinicianId);
		} else if (!newClinicianIds.includes(clinicianId)) {
			// Add clinician if not present
			newClinicianIds.push(clinicianId);
		}

		this.setState({
			clinicianIds: newClinicianIds,
			clinicianTenures: {
				...this.state.clinicianTenures,
				[clinicianId]: tenures,
			},
			showTenureModal: false,
			selectedClinicianForTenure: null,
			preTenureModalState: null,
		});
	};

	closeTenureModal = () => {
		const { preTenureModalState } = this.state;
		if (preTenureModalState) {
			this.setState({
				clinicianIds: preTenureModalState.clinicianIds,
				clinicianTenures: preTenureModalState.clinicianTenures,
				showTenureModal: false,
				selectedClinicianForTenure: null,
				preTenureModalState: null,
			});
		} else {
			this.setState({
				showTenureModal: false,
				selectedClinicianForTenure: null,
			});
		}
	};

	handleClinicianChipClick = (clinicianId) => {
		const clinician = this.props.clinicians.find((c) => c.id === clinicianId);
		if (clinician) {
			this.setState({
				preTenureModalState: {
					clinicianIds: this.state.clinicianIds,
					clinicianTenures: this.state.clinicianTenures,
				},
				showTenureModal: true,
				selectedClinicianForTenure: clinician,
			});
		}
	};

	handleDateChange = (id) => (date) => {
		if (isNil(date)) {
			date = 'Invalid date';
		} else {
			date = parseISO(moment(date).format('YYYY-MM-DD'));
		}

		this.setState({ [id]: date });
	};

	// Optional (MTC-173): a blank end date makes the group ongoing.
	handleEndDateChange = (date) => {
		this.setState({ endDate: date || null });
	};

	handleCancel = () => {
		this.closeModal();
	};

	buildTenuresPayload = () => {
		const { clinicianTenures } = this.state;
		const payload = [];

		const allIds = Object.keys(clinicianTenures).map(Number);
		allIds.forEach((clinicianId) => {
			const tenures = clinicianTenures[clinicianId] || [];
			tenures.forEach((t) => {
				payload.push({
					clinicianId,
					startDate: t.startDate,
					endDate: t.endDate || null,
					id: t.id || undefined,
					delete: t.delete || false,
				});
			});
		});

		return payload.sort((a, b) => a.clinicianId - b.clinicianId || (a.startDate > b.startDate ? 1 : -1));
	};

	handleCreate = () => {
		const { createProgram } = this.props;
		const {
			price,
			startDate,
			endDate,
			repeatsOn,
			repeats,
			location,
			startTime,
			endTime,
			groupType,
			groupSize,
			inPerson,
			meetingLink,
			timeZone,
			clinicianIds,
		} = this.state;

		const programData = {
			groupName: groupType,
			location,
			price,
			repeatFrequency: repeats,
			groupSize,
			startDate: moment(startDate).format('YYYY-MM-DD HH:mm:ss'),
			endDate: formatEndDateForApi(endDate),
			startTime: moment(startTime).format('HH:mm'),
			endTime: moment(endTime).format('HH:mm'),
			repeatsOn,
			inPerson,
			meetingLink,
			timeZone,
			clinicianIds,
			clinicianTenures: this.buildTenuresPayload(),
		};

		createProgram(programData);
		this.closeModal();
	};

	computeDiff = () => {
		const {
			price,
			startDate,
			endDate,
			repeatsOn,
			repeats,
			location,
			startTime,
			endTime,
			groupType,
			groupSize,
			inPerson,
			meetingLink,
			timeZone,
			clinicianIds,
		} = this.state;

		const stateData = {
			price,
			startDate: moment(startDate).format('YYYY-MM-DD'),
			endDate: formatEndDateForApi(endDate),
			repeatsOn: repeatsOn,
			repeatFrequency: repeats,
			location,
			startTime: moment(startTime).format('HH:mm:ss'),
			endTime: moment(endTime).format('HH:mm:ss'),
			groupName: groupType,
			groupSize,
			inPerson,
			meetingLink,
			timeZone,
			clinicianIds: [...clinicianIds].sort((a, b) => a - b),
			clinicianTenures: this.buildTenuresPayload(),
		};

		const propsData = {
			groupName: this.props.groupData.groupName,
			groupSize: this.props.groupData.groupSize,
			location: this.props.groupData.location,
			price: this.props.groupData.price,
			startDate: this.props.groupData.startDate
				? moment(this.props.groupData.startDate).format('YYYY-MM-DD')
				: null,
			// The UTC calendar day, as componentDidMount reads it: the DATE column arrives
			// at UTC midnight, so a local read diffs an untouched end date a day early.
			endDate: this.props.groupData.endDate
				? moment.utc(this.props.groupData.endDate).format('YYYY-MM-DD')
				: null,
			repeatsOn: this.props.groupData.repeatsOn || [],
			repeatFrequency: this.props.groupData.repeatFrequency || 'Weekly',
			startTime: this.props.groupData.startTime
				? moment.utc(this.props.groupData.startTime).tz(this.state.timeZone).format('HH:mm:ss')
				: moment().hour(9).minute(0).format('HH:mm:ss'),
			endTime: this.props.groupData.endTime
				? moment.utc(this.props.groupData.endTime).tz(this.state.timeZone).format('HH:mm:ss')
				: moment().hour(10).minute(0).format('HH:mm:ss'),
			inPerson: this.props.groupData.inPerson || false,
			meetingLink: this.props.groupData.meetingLink || '',
			timeZone: this.state.timeZone,
			clinicianIds: UpdateGroup.getActiveClinicianIds(this.props.groupData.clinicians || []),
			clinicianTenures: [...(this.props.groupData.clinicians || [])].map((c) => ({
				clinicianId: c.clinicianId,
				startDate: c.startDate,
				endDate: c.endDate || null,
				id: c.id,
				delete: false,
			})).sort((a, b) => a.clinicianId - b.clinicianId || (a.startDate > b.startDate ? 1 : -1)),
		};

		const q = getObjectDifference(stateData, propsData);
		return { q, stateData };
	};

	handleEdit = () => {
		const { q, stateData } = this.computeDiff();
		stateData.q = q;
		stateData.programId = this.props.groupData.programId;

		const { updateProgram } = this.props;

		// Send to server — if sessions with leave requests are affected,
		// the server returns a 409 and componentDidUpdate shows the warning modal
		// with the actual affected sessions list.
		this.setState({ pendingStateData: stateData });
		updateProgram(stateData);
	};

	handleConfirmSessionDeletion = () => {
		const { updateProgram } = this.props;
		const { pendingStateData } = this.state;

		if (!pendingStateData) {
			this.setState({ showSessionWarning: false });
			return;
		}

		updateProgram({
			...pendingStateData,
			confirmDelete: true,
		});

		this.setState({ showSessionWarning: false });
	};

	handleCancelSessionDeletion = () => {
		this.setState({
			showSessionWarning: false,
			affectedSessions: [],
			pendingStateData: null,
		});
	};

	handleTimeChange = (id) => (time) => {
		this.setState({ [id]: time });
	};

	checkWeekdaysIsSelected = () => {
		const { weekDays } = this.state;
		for (let i = 0; i < weekDays.length; i++) {
			if (weekDays[i].isSelected === true) {
				return true;
			}
		}
		return false;
	};

	allChecked = (startTime, endTime, startDate, repeat, groupType) => {
		const isTimeError =
			startTime && endTime && moment(startTime).isAfter(moment(endTime));

		if (repeat === 'Weekly') {
			if (!this.checkWeekdaysIsSelected()) return true;
		}

		if (
			!startTime ||
			!endTime ||
			startDate === 'Invalid date' ||
			isTimeError ||
			!groupType
		) {
			return true;
		}
		return false;
	};

	_isDirty = () => {
		const key = JSON.stringify({
			s: this.state.clinicianIds,
			t: this.state.clinicianTenures,
			p: this.state.price,
			sd: this.state.startDate,
			ed: this.state.endDate,
			ro: this.state.repeatsOn,
			rf: this.state.repeats,
			l: this.state.location,
			st: this.state.startTime,
			et: this.state.endTime,
			gt: this.state.groupType,
			gs: this.state.groupSize,
			ip: this.state.inPerson,
			ml: this.state.meetingLink,
		});
		if (this._isDirtyCache && this._isDirtyCache.key === key) {
			return this._isDirtyCache.value;
		}
		const value = this.computeDiff().q.length > 0;
		this._isDirtyCache = { key, value };
		return value;
	};

	render() {
		const {
			modal,
			price,
			location,
			startDate,
			endDate,
			groupType,
			startTime,
			endTime,
			groupSize,
			weekDays,
			meetingLink,
			clinicianIds,
			repeats,
		} = this.state;

		const { mode, clinicians } = this.props;

		const isDirty = mode !== 'edit' || this._isDirty();

		const isTimeError = Boolean(
			!startTime || !endTime || moment(startTime).isAfter(moment(endTime)),
		);

		return (
			<>
			<Modal isOpen={modal} className="modal-dialog-centered" backdrop="static">
				<ModalHeader toggle={this.closeModal} className="px-4 border-0">
					<div className="">
						{' '}
						{mode === 'create' ? 'Create Therapy' : 'Update Therapy'}
					</div>
				</ModalHeader>
				<ModalBody
					className="p-0"
					style={{
						maxHeight: 'calc(100vh - 200px)',
						overflow: 'hidden',
					}}
				>
					<div
						className="form-body px-3 mb-4"
						style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}
					>
						<Form>
							<div className="form-group">
								<label
									htmlFor="exampleInputEmail1"
									className="text-uppercase text-muted font-10"
								>
									Facilitators*
								</label>
								<SelectAutoComplete
									multiple
									handleChange={this.handleMultiSelect}
									options={clinicians.map(({ id, name, ...rest }) => ({
										value: id,
										label: name,
										...rest,
									}))}
									value={this.getClinicianIds()}
									placeholder="Select Clinician"
									onChipClick={this.handleClinicianChipClick}
									isClearable={false}
								/>
							</div>
							<div className="form-group">
								<label
									htmlFor="exampleInputEmail1"
									className="text-uppercase text-muted font-10"
								>
									Therapy Name*
								</label>
								<div className="d-flex align-items-center border py-2">
									<input
										type="text"
										required="required"
										value={groupType}
										id="groupType"
										name="groupType"
										className="font-17 col-8 pl-2"
										onChange={this.handleChange}
									/>
								</div>
							</div>
							<div className="form-group">
								<label
									htmlFor="exampleInputEmail1"
									className="text-uppercase text-muted font-10"
								>
									Location*
								</label>
								<Select
									value={location}
									className="custom-select"
									id="location"
									name="location"
									onChange={this.handleChange}
									disabled={mode === 'edit'}
								>
									<option key="Marin" value="Marin">
										Marin
									</option>
									<option key="San Francisco" value="San Francisco">
										San Francisco
									</option>
								</Select>
							</div>
							<div className="form-group row">
								<div className="col-6">
									<label
										htmlFor="exampleInputEmail1"
										className="text-uppercase text-muted font-10"
									>
										Size*
									</label>
									<Select
										value={groupSize}
										className="custom-select"
										id="groupSize"
										name="groupSize"
										onChange={this.handleChange}
									>
										<option key="Group" value="Group">
											Group
										</option>
										<option key="Individual" value="Individual">
											Individual
										</option>
									</Select>
								</div>
								<div className="col-6">
									<label
										htmlFor="updateGroupPrice"
										className="text-uppercase text-muted font-10"
									>
										Price per month*
									</label>
									<div className="d-flex align-items-center border py-2">
										<div className="font-17 pl-3 pr-1">$</div>
										<input
											type="number"
											required="required"
											value={price}
											min={0}
											id="price"
											name="price"
											className="font-17 col-10"
											onChange={this.handleChange}
											style={{
												height: 18,
											}}
										/>
									</div>
								</div>
							</div>
							<div className="form-group">
								<div className="form-group mt-1">
									<CustomDatePicker
										label={<span className="form-group">START DATE*</span>}
										minDate={new Date()}
										id="startDate"
										selected={startDate}
										handleDateChange={this.handleDateChange('startDate')}
										disabled={moment(startDate).isBefore(moment(), 'D')}
									/>
									<div className="d-flex align-items-end">
										<div className="flex-grow-1">
											<CustomDatePicker
												label={<span className="form-group">END DATE</span>}
												id="endDate"
												selected={endDate}
												handleDateChange={this.handleEndDateChange}
												minDate={this.state.startDate || new Date()}
											/>
										</div>
										{endDate && (
											<button
												type="button"
												className="btn btn-link font-10 text-uppercase ml-2 mb-2"
												aria-label="Clear end date"
												onClick={() => this.handleEndDateChange(null)}
											>
												Clear
											</button>
										)}
									</div>
									<small className="text-muted d-block mb-3">
										Leave blank for an ongoing group.
									</small>
									<div className="d-flex mb-3">
										<div className="col-12 p-0">
											{/* <div className="col-12 p-0">
                            <label
                              htmlFor="updateGroupPrice"
                              className="text-uppercase text-muted font-10"
                            >
                              Repeats*
                            </label>
                            <Select
                              value={repeats}
                              className="custom-select"
                              id="repeats"
                              name="repeats"
                              onChange={this.handleChange}
                            >
                              {repeatAction.map((val) => (
                                <option key={val} value={val}>
                                  {val}
                                </option>
                              ))}
                            </Select>
                          </div> */}
											{this.state.repeats === 'Weekly' && (
												<div className="d-flex col p-0 justify-content-center mt-2">
													{weekDays.map((value, key) => (
														<span
															className={
																value.isSelected
																	? 'col badge badge-pill text-bold badge-success border py-2 text-uppercase font-10 hand'
																	: 'col badge badge-pill bg-white border py-2 badge-color-cust text-uppercase font-10 link-color hand'
															}
															onClick={(e) => this.weekDaysSelect(e, key)}
															key={value.name}
														>
															{value.name}
														</span>
													))}
												</div>
											)}
										</div>
									</div>
									<div className="d-flex mb-3 justify-content-between">
										<div className="col-5 p-0">
											<label
												htmlFor="updateGroupPrice"
												className="text-uppercase text-muted font-10"
											>
												Start Time*
											</label>
											{/* <div className="d-flex align-items-center border py-2 px-3"> */}
											<CustomTimePicker
												id="startTime"
												selected={startTime}
												handleTimeInput={this.handleTimeChange('startTime')}
												className="font-17"
											/>
										</div>
										<div className="col-5 p-0">
											<label
												htmlFor="updateGroupPrice"
												className="text-uppercase text-muted font-10"
											>
												{'End Time*'}
											</label>

											<CustomTimePicker
												id="endTime"
												selected={endTime}
												minTime={startTime}
												maxTime={moment()
													.set('hours', 23)
													.set('minutes', 55)
													.toDate()}
												handleTimeInput={this.handleTimeChange('endTime')}
												className="font-17 w-150"
												// timeCaption="Time"
											/>
											{isTimeError && (
												<span className="form-error">Invalid Time Range</span>
											)}
										</div>
									</div>
									<div className="form-group">
										<label
											htmlFor="meetingLink"
											className="text-uppercase text-muted font-10"
										>
											Meeting Link 
											<OverlayTrigger
												placement="top"
												overlay=
													{<Tooltip id="tooltip">
														Link must start with https://
													</Tooltip>}
											>
												<InfoIcon color="grey" className="ml-1"/>
											</OverlayTrigger>
										</label>
										<div className="d-flex align-items-center border py-2">
											<input
												type="text"
												value={meetingLink}
												id="meetingLink"
												name="meetingLink"
												className="font-17 col-8 pl-2"
												onChange={this.handleChange}
												placeholder="https://meet.google.com/abc-xyz"
											/>
										</div>
									</div>	
									<div className="d-flex justify-content-end">
										<div
											className="mr-2"
											onClick={this.handleCheck('inPerson')}
										>
											In Person
										</div>
										<CustomCheckbox
											id="inPerson"
											checked={this.state.inPerson}
											onChange={this.handleCheck('inPerson')}
											classNames={{
												container: 'align-self-center',
											}}
											styles={{
												container: { marginBottom: 34 },
											}}
										/>
									</div>
								</div>
							</div>
						</Form>
					</div>
					<div className="d-flex justify-content-end align-items-center mb-3 px-3">
						<div className="d-flex justify-content-end align-items-center">
							<button
								type="button"
								className="btn btn-primary btn-border btn-color-cust mr-2 px-5 py-3 text-uppercase font-11 link-color"
								onClick={this.handleCancel}
							>
								Cancel
							</button>
							<button
								disabled={this.allChecked(
									startTime,
									endTime,
									startDate,
									repeats,
									groupType,
								) || clinicianIds.length === 0 || !isDirty || this.props.isUpdating}
								type="button"
								className="btn btn-primary btn-border primary-btn-color px-5 py-3 text-uppercase font-11"
								onClick={mode === 'edit' ? this.handleEdit : this.handleCreate}
							>
								{this.props.isUpdating ? 'Saving...' : 'Save'}
							</button>
						</div>
					</div>
				</ModalBody>
			</Modal>
			<SessionDeletionWarningModal
				isOpen={this.state.showSessionWarning}
				toggle={this.handleCancelSessionDeletion}
				affectedSessions={this.state.affectedSessions}
				onCancel={this.handleCancelSessionDeletion}
				onConfirm={this.handleConfirmSessionDeletion}
			/>
			<ClinicianTenureModal
				isOpen={this.state.showTenureModal}
				toggle={this.closeTenureModal}
				clinician={this.state.selectedClinicianForTenure}
				existingTenures={
					this.state.selectedClinicianForTenure
						? this.state.clinicianTenures[this.state.selectedClinicianForTenure.id] || []
						: []
				}
				groupStartDate={this.props.groupData?.startDate}
				onSave={this.handleSaveTenures}
			/>
			</>
		);
	}
}

UpdateGroup.propTypes = {
	hide: PropTypes.func.isRequired,
	groupData: PropTypes.object,
	mode: PropTypes.string,
	clinicians: PropTypes.array,
	createProgram: PropTypes.func,
	type: PropTypes.string,
	role: PropTypes.string,
	// auth.loggedInUser.id, which the login payload carries as a number.
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	updateProgram: PropTypes.func,
	updateConflict: PropTypes.object,
	isUpdating: PropTypes.bool,
};

export default UpdateGroup;
